import { css } from '@emotion/react'
import { useMemo } from 'react'
import { Table, Row, Text } from 'common-components'
import { ColumnsType } from 'antd/lib/table'
import { CertificationUserTestQuestionType } from '@types'

type CertificationTablePropsType = {
  questionsRespondentFiltered: CertificationUserTestQuestionType[]
}

const CertificationTable = ({ questionsRespondentFiltered }: CertificationTablePropsType) => {
  const tableColumns: ColumnsType<CertificationUserTestQuestionType> = useMemo(
    () => [
      {
        title: 'ID Question',
        dataIndex: 'idCertificationUserTestQuestion',
        key: 'idCertificationUserTestQuestion',
        render: (id: CertificationUserTestQuestionType['idCertificationUserTestQuestion']) => (
          <Row
            css={css`
              width: 907px;
            `}
            align={'middle'}
          >
            {id}
          </Row>
        ),
      },
      {
        title: 'Temps de passage',
        dataIndex: 'duration',
        key: 'duration',
        render: (duration: CertificationUserTestQuestionType['duration']) => (
          <Row
            align={'middle'}
            css={css`
              gap: 18px;
            `}
          >
            <Text>{duration}</Text>
            {/*<PercentTag state="positive" withIcon={false}>*/}
            {/*	TOP 1%*/}
            {/*</PercentTag>*/}
          </Row>
        ),
      },
      {
        title: 'Score',
        dataIndex: 'mark',
        key: 'mark',
        render: (mark: CertificationUserTestQuestionType['mark']) => (
          <Row
            align={'middle'}
            css={css`
              gap: 18px;
            `}
          >
            <Text>{mark && `${mark}%`}</Text>
            {/*<PercentTag state="positive" withIcon={false}>*/}
            {/*	TOP 1%*/}
            {/*</PercentTag>*/}
          </Row>
        ),
      },
    ],
    [],
  )

  return <Table data={questionsRespondentFiltered} columns={tableColumns} />
}

export default CertificationTable
